import { type FC } from 'react';
import { NumberInput, Select } from '@mantine/core';
import { type GetInputPropsReturnType } from '@mantine/form';
import { calculationRuleOptions } from '../../model';

interface TraderRateFieldsProps {
    calculationRuleInputProps: GetInputPropsReturnType;
    commissionInputProps: GetInputPropsReturnType;
    disabled?: boolean;
}

export const TraderRateFields: FC<TraderRateFieldsProps> = ({
    calculationRuleInputProps,
    commissionInputProps,
    disabled,
}) => {
    return (
        <>
            <NumberInput
                label='Комиссия'
                placeholder='Введите число'
                valueIsNumericString
                min={0}
                disabled={disabled}
                {...commissionInputProps}
            />

            <Select
                label='Правило расчёта'
                placeholder='Выберите правило'
                data={calculationRuleOptions}
                searchable
                allowDeselect={false}
                disabled={disabled}
                {...calculationRuleInputProps}
            />
        </>
    );
};
